export default {
  lang: {
    CustomerUser: 'Customer User',
    switchTo: 'Switch to',
    internetOffline: 'Internet connection failed, please try again later.',
    notice: 'Notice',
    noticeTitle: 'We have detected that some services active on your account have now passed the free trial period',
    noticeContent1: 'During the ongoing Coronavirus pandemic, free services will not be discontinued without consent. To continue using these services, please read and agree to the',
    noticeContent2: 'To actively discontinue services, please contact features@tvunetworks.com',
    /* ---- Modem Module ---- */
    Roaming: 'Roaming',
    AvailableSlots: 'Available Slots',
    RoamingForAllModems: 'Roaming for all modems',
    DialNumber: 'Dial Number',
    RestoreDefaults: 'Restore Defaults',
    RestoreDefaultsTips: 'This will reset the modem to factory default settings. All custom configurations including APN, username, password, and dial number will be lost.',
    RestoreSuccess: 'Restore defaults applied successfully.',
    Apply: 'Apply',
    IMEI: 'IMEI',
    ICCID: 'ICCID',
    ESNIMSI: 'ESN/IMSI',
    UserName: 'User Name',
    Password: 'Password',
    Encryption: 'Encryption',
    APN: 'APN',
    Modem: 'Modem',
    Disable: 'Disable',
    DisableAllModems: 'Disable all modems',
    DisableThisModem: 'Disable this modem',
    Canceled: 'Canceled',
    AreYouSureToContinue: 'Are you sure you want to continue?',
    DisableRoaming: 'Disable Roaming?',
    DisableRoamingTips: 'Disabling roaming may disconnect you from international networks and prevent access while abroad. In addition, support may be unable to assist you remotely if issues arise.',
    RoamingSuccessForSlot: 'Roaming for slot {0} is disabled.',
    RoamingDisabledSuccessAll: 'All modems’s Roaming is disabled.',
    RoamingEnabledSuccessAll: "All modems's Roaming is enabled.",
    RoamingEnabledSuccessForSlot: 'Roaming for slot {0} is enabled.',
    RoamingDisabledSuccessForSlot: 'Roaming for slot {0} is disabled.',
    RoamingApplySuccess: 'Applied successfully.',
    RoamingCarrierApplyFailed: 'Applied failed. Please check and try again later.',
    RoamingModeApplyFailed: 'Failed to change roaming mode. Please try again.',
    dialNumberIsRequired: 'Dial number is required',
    ApplySuccess: 'Applied successfully',
    ApplyFailed: 'Apply failed',
    select: 'select',
    DHCP: 'DHCP',
    Static: 'Static',
    AUTO: 'AUTO',

    /* ---- title ---- */
    webrTitile: 'TVU Receiver',
    titlePre: 'TVU Command Center3.0',
    TMySource: 'My Sources',
    TAdvanceControl: 'Advanced Control',
    TMultiControl: 'Multi Control',
    TMyReceivers: 'My Receivers',
    TSetting: 'Setting',
    TMultiView: 'Multi-View',
    MultiControl: 'Multi-Control',
    SMonitor: 'SMonitor',
    TShare: 'Share',
    TToken: 'Token',
    TAlert: 'Alert',
    GridViaToken: 'TVU Grid via Token',
    GlobalGrid: 'Global Grid',

    title: 'Command Center',
    title1: 'Switch',
    total: 'Total',
    inputDescrible: 'Video Name',
    modelTips: 'Tips',
    searchT: 'Source Name',
    searchTText: 'PeerID/Name/URL',
    searchTTextRc: 'PeerID or Name',
    equipmentName: 'Name：',
    equipmentIdentity: 'PeerID：',
    platform: 'Platform',

    /* ---- status ---- */
    status: 'Status',
    online: 'Online',
    offline: 'Offline',
    live: 'Live',
    going: 'Ongoing Event',

    /* ---- button ---- */
    stop: 'Stop',
    Switch: 'Take',
    Take: 'Take',
    Stop: 'Stop',
    Ok: 'Ok',
    On: 'On',
    Off: 'Off',
    cancel: 'Cancel',
    Cancel: 'Cancel',
    close: 'No',
    confirm: 'Yes',
    loading: 'Loading',
    stopping: 'Stopping',
    pushing: 'Pushing',

    /* ---- filter ---- */
    source: 'Source',
    destination: 'Destination',
    Enable: 'Enable',
    grid: 'TVU Grid',
    logout: 'Sign Out',
    allall: 'All',
    sort: 'Sort by Status',
    Type: 'Type',
    receiver: 'Receiver',
    version: 'Version',

    /* ---- popup ---- */
    notSource: 'Please select a source.',
    rightNumber: 'Please input right number.',
    NoResult: 'No Results Found',
    of: 'of',
    serverError: 'The operation failed, please try again later',
    ReceiverNotFound: 'Receiver not found, please confirm and try again',
    ReceiverOffLine: 'Receiver is offline',
    sourceNotExist: 'Source does not exist',
    ParamError: 'Server error, please contact TVU Support',
    SendToRFail: 'Server error, please contact TVU Support',
    youtubeSendToRFail: 'Youtube failed to send to receiver',
    DeviceOffLine: 'Source offline',
    ReceiverOnLive: 'This receiver is LIVE with another transmitter. Would you like to stop it and start LIVE with this transmitter?',
    ReceiverOnLive1: 'This receiver is LIVE with another transmitter',
    ReceiverOnLive2: 'Would you like to stop it and start LIVE with this transmitter?',
    ReceiverDeviceOnLine: 'This transmitter is LIVE with another receiver. Would you like to stop it and start LIVE with this receiver?',
    ReceiverDeviceOnLine1: 'This transmitter is LIVE with another receiver',
    ReceiverDeviceOnLine2: 'Would you like to stop it and start LIVE with this receiver?',
    isAutoReceiver: 'This transmitter is LIVE with auto channel, would you like to stop it.',
    isAutoRLive: 'Would you want to use auto receiver to LIVE this transmitter',
    isManualReceiver: 'This transmitter is LIVE with manual channel, would you like to stop it.',
    DeviceOnLine: 'Current source device is on live, do you still want to continue this operation?',
    RnotfoundthisSource: 'Source not found, please confirm and try again',
    ReceiverNotLive: 'Receiver is not live',
    ReceiverNotLiveWithSource: 'Receiver not live with source',
    timeOut: 'Request timed out. Please try again.',
    // CC-2293：RPS81 写操作统一反馈出口新增 key，不复用上面全站共享的 timeOut——
    // 这条要点名"设备未响应"，与泛化的请求超时文案语义不同 [Claude Code]
    rpsOpSuccessTip: 'Operation completed successfully.',
    rpsOpTimeoutTip: 'Device did not respond in time. Please check the connection and try again.',
    // W4（Step 5.5 真机坐实）：WS 连接断开与"设备未响应"是不同语义——前者请求根本没送达，
    // 后者已送达只是设备迟迟不回。文案不能说"设备"，避免把用户引去查设备配置 [Claude Code]
    rpsOpDisconnectedTip: 'Connection lost. Please check your network and try again.',
    rpsOpFailedTip: 'Operation failed. Please try again.',
    rpsOpPartialFailedTip: 'Some operations failed: {0}',
    // WR-346: 初始化接口超时后守卫兜底放行，页面无用户信息时的提示 [Claude Code]
    initUserInfoFailedTips: 'Failed to load your account information. Some features may be unavailable.',
    // WR-346 F: 重定向循环断路后的提示（账号没有任何可访问页面）[Claude Code]
    pagePermissionInvalidTips: 'No page is available for your account. Please contact your administrator.',
    // WR-346 B: initConfig（全局配置）加载失败时的提示 [Claude Code]
    initConfigFailedTips: 'Failed to load the configuration. Some features may not work properly.',
    /* ---- my source page ---- */
    locationFailed: 'Transceiver location acquisition failed',
    extSourceNameTips: 'Name cannot be empty and must be 3 characters minimum.',
    GLinkSourceIpTips: 'Please enter the correct IP format!',
    GLinkSourcePortTips: 'Please enter the correct port format!',
    GlinkUpperLimit: 'The number of IPs and ports has reached the upper limit',
    selectOutputFormat: 'Please select a output format',
    extSourceTokenTips: 'Token cannot be empty.',
    trackCollection: 'Track Collection',
    realTime: 'Real Time',
    history: 'History',
    multiTracking: 'Multi-tracking',
    addCpllection: 'Add to Track Collection',
    collectionName: 'Collection Name',
    deleteCollection: 'Delete this collection',
    collectionPrompt: 'After saving, it can be used as a reference track in “Multi-tracking" mode',
    confirmBtn: 'Confirm',
    deleteOnlyCollectionPrompt: 'The “Multi-tracking” mode requires at least one collection.Do you still want to delete this collection?',
    deleteCollectionPrompt: 'Do you want to delete this collection?',
    selectCollection: 'Please select the collection trajectory',

    /* ---- advanced control page ---- */
    validate: 'Validate',
    validating: 'validating...',
    record: 'Record',
    downloadAll: 'Download All',
    Preview: 'Preview',
    Download: 'Download',
    state: 'State',
    size: 'Size',
    compeleted: 'Completed',
    Play: 'Play',
    deleteAll: 'Delete All',
    downList: 'DownList',
    downloadAs: 'Download as',
    exportName: 'Name',
    exportFormat: 'Format',
    saveAs: 'Save As',
    export: 'Export',
    /* ---- popup ---- */
    notSelectClip: 'Please select you want to export clip.',
    moreThanLimitation: 'Max number of previews - {0} has been reached. Please turn off other preview windows first.',
    syncTitle: 'Time Lock is only availble when selected receivers are live with TVU Pack',
    syncCanUseTitle: "Start failed, please check the R and T version is more than 6.1 or not, it's right please select al least two receiver. ",
    notHaveSyncFeature: 'Device {0} not access tpc time lock feature',
    synchronizing: 'Device is synchronizing',
    deviceSynchronizing: 'Exist device synchronizing by other account',
    maxMultiControlNumber: 'You can only select six video to preview',
    notLastOne: 'You need to delete from last one',
    picturesFormat: 'The max picture size is 640*480',

    // advanced control settingDaiog
    notRecording: 'Not recording',
    Recording: 'Recording',
    clipboard: 'Copy Full Name to Clipboard',
    downloadedFiles: 'Downloaded Files',
    startTime: 'Start Time',
    endTime: 'End Time',
    compeletedTime: 'Completed Time',
    noBindUser: 'no bind user',
    emailNotExist: 'Email not exist',
    // nameRequired: 'Please enter name',
    urlRequired: 'Please enter URL',
    urlPathRequired: 'Please enter URL / Path',

    /* ---- Booking ---- */
    selectR: 'Select a destination',
    monthKey: 'Month',
    weekKey: 'Week',
    dayKey: 'Day',
    todayKey: 'Today',
    invalidEvent: 'This event is completed',
    // booking.common
    bookingRTimeconflict: 'Receiver booking schedule conflict',
    bookingTTimeconflict: 'TVUPack booking schedule conflict',
    // booking.addEvent
    endTimeMoreCurTime: 'The end time must be greater than the current time',
    endTimeMoreStartTime: 'The end time must be greater than the start time',
    deadLineMoreEndTime: 'The deadline must be greater than the start time and end time',
    startTimeMoreCurTime: 'The start time must be greater than the current time',
    invalidSourcePeerId: 'Invalid Source Peer ID',
    invalidDestPeerId: 'Invalid Destination Peer ID',
    sourceTypeIsNull: 'Source type is empty',
    invalidStartTime: 'Invalid startTime',
    invalidEndTime: 'Invalid endTime',
    biggerEndTime: 'End Time must be greater than Start Time',
    biggerStartTime: 'Start Time must be greater than now',
    sourceSetDelay: 'Delay value cannot be empty for TVUPack sources',
    delayInputRange: 'Delay: 0.5s to 50s',
    sourceSetBitrate: 'Delay value cannot be empty for TVUPack sources',
    bitrateInput: 'Bitrate: 100kbps - 10240kbps',
    sourceSetUrl: 'URL cannot be empty for External Source',
    matrixSetOutputId: 'The Matrix destination must set outputId',
    matrixSetSwitchtype: 'The Matrix destination must set switchtype',
    setswitchtype: 'The Switch Type must be 1 or 2',
    matrixSupport: 'The Matrix only supports EXT or SDI source',
    sdiInNotSupport: 'This SDI source does not support Matrix',
    cannotModifyEvent: 'Finished events cannot be modified',
    endTimeBigger: 'End Time must be greater than now',
    startTimeBigger: 'Start Time must be greater than now',
    cannotModifyStartTime: 'Cannot modify Start Time',
    refuseCall: 'Peer refuse call request!',
    // booking.delete
    deleteEventFail: 'Event delete operation failed',
    eventIdEmpty: 'Event ID is empty',
    // booking.update
    eventNotexist: 'Event not exist',
    eventNotEdit: 'Event will end in one minute. Editing not permitted. ',
    matrixEventCannotModify: 'Matrix Booking Event cannot be modified',
    notEditEvent: 'Cannot edit this event',
    msgpipeConnectError: 'Msgpipe connect error',
    accountExpired: "The selected '{nickName}' streaming accounts have expired, please re-authenticate",

    /* ---- title ---- */
    Bookmark: 'Bookmark',

    /* ---- home ---- */
    adjustCamera: 'Adjust Camera',
    manualPan: 'Manual Pan',
    autoPan: 'Auto Pan',
    Close: 'Close',
    reset: 'Reset',
    receiverID: 'Receiver ID:',
    playerVersion: 'Player Version:',
    recRemain: 'Rec remain:',
    coreVersion: 'Core Version:',
    productVersion: 'Product Version:',
    buildDate: 'Build Date:',
    IdleCpu: 'Idle CPU:',
    genlock: 'Genlock:',
    CpuTemp: 'CPU Temperature:',
    FreeMem: 'Free Memory:',
    RemainSpace: 'Storage Remaining:',
    SpaceRemainTime: 'Time Remaining:',
    LoadAvg1Min: 'Load Average 1min:',
    LoadAvg5Min: 'Load Average 5min:',
    LoadAvg15Min: 'Load Average 15min:',

    favorite: 'My Favorite',
    Codec: 'Codec',
    CardID: 'Card ID',
    pleaseWait: 'Request has been sent. Please wait.',
    cameraOff: 'No camera.',
    i18n_startLiveFailed: 'Starting live failed.',
    sourceNotHave: 'The current source is not in current account.',
    copy: 'Duplicate',
    create: 'Create',
    delete: 'Delete',
    filters: 'Filters',
    apply: 'Apply',
    applying: 'Applying',
    start: 'Start',
    end: 'Stop',
    duration: 'Duration',
    operation: 'Operation',
    createTitle: 'Title',
    time: 'Time',
    // to: 'to',
    delay: 'Delay',
    bit: 'Bitrate',
    failed: 'Failed',
    pending: 'Pending',
    edit: 'Edit',
    RVersion: 'R version:',
    RPeerID: 'R PeerID:',
    ErrorRate8s: 'Error Rate(8s):',
    ErrorRate1s: 'Error Rate(1s):',
    LineQuality8s: 'Line Quality(8s):',
    LineQuality1s: 'Line Quality(1s):',
    TBattery: 'Battery:',
    TInput: 'Video Input:',
    TFormat: 'Input Format:',
    RFormat: 'Output Format:',
    Output: 'Output',
    ProcessID: 'Process ID',
    Frames: 'Frames',
    Fps: 'FPS',
    IFB: 'IFB:',
    IFBSignal: 'IFB Signal:',
    VoIPSignal: 'VoIP Signal:',
    VoIPOut: 'Audio Out',
    VoIPIn: 'Audio In',
    Delay: 'Delay',
    Bitrate: 'Bitrate',
    kbps: 'kbps',
    Dynamic: 'Dynamic',
    Fixed: 'Fixed',
    VBR: 'VBR',
    CBR: 'CBR',
    Quality: 'Quality:',
    Alert: 'Alert',
    MultiView: 'MultiView',
    EventAlert: 'Event Alert',
    Token: 'Token',
    Booking: 'Booking',
    Share: 'Share',
    Setting: 'Setting',
    FileDownload: 'FileDownload',
    More: 'More',
    ReceiverNotExist: 'Receiver not exist',
    Sourceliving: 'The source is living',
    ReceiverNotConnect: 'Receiver not connect',
    ReceiverError: 'Unknown',
    PeerNotFound: 'The current peer is not found',
    selectEventFirst: 'Please select an event first',
    confirmHttps: 'VoIP uses HTTPS protocol which may slightly slow down the page.',
    HadVoip: 'To continue with VoIP, please stop the last active session first.',
    AnalyzeUrlFail: 'The current url is not available.',
    AnalyzingUrl: 'Analyzing Url...',
    AnalyzingFail: 'Analyzing failed',
    AnalyzingSuccess: 'Analyzing success',
    getLocalMediaFail: 'Failed to get access to local media',
    EndVoIP: 'The call has ended',
    Details: 'Details',
    note: 'Note',
    device: 'Device',
    color: 'Color',
    save: 'Save',
    creating: 'Creating',
    TVUPack: 'TVUPack',
    TVUAnywhere: 'TVUAnywhere',
    'Grid-Pack': 'TVU Grid-Pack',
    'Grid-SDI': 'TVU Grid-SDI',
    Ext: 'Ext',
    'Local-SDI': 'Local SDI',
    'SMPTE Local': 'SMPTE Local',
    SMPTE2022: 'SMPTE2022',
    YouTube: 'YouTube',
    SRT: 'SRT',
    selectReceiver: 'Select Receiver',
    Name: 'By Name',
    Online: 'Online First',
    Live: 'Live First',
    Filter: 'Filter',
    trackName: 'Tracking',
    addExtSource: 'Add External Source',
    editExtSource: 'Edit External Source',
    addGLinkSource: 'Add G-Link Source',
    editGLinkSource: 'Edit GLink Source',
    name: 'Name',
    Save: 'Save',
    BasicSetting: 'Basic Setting',
    General: 'General',
    TimeZone: 'Time Zone',
    FeatureControl: 'Feature Control',
    uploadFileTooLarge: 'Image size exceeds the limit',
    SMPTESetting: 'SMPTE 2110 Setting',
    GridEncoder: 'TVU Grid Encoder',
    GLinkEncoder: 'GLink Encoder',
    Transcriber: 'Transcriber',
    SDIOutput: 'SDI Output Setting',
    AutoRecord: 'Auto Record',
    IPStreamOut: 'IP Stream Out',
    FileBrowser: 'File Browser',
    AutoDownload: 'Auto Download',
    ProgressiveDownload: 'Progressive Download',
    localAllPackPosition: 'Locate All Pack Position',
    SetLocation: 'Set Location',
    IPandPortMapping: 'IP and Port Mapping',
    SetMedia: 'Set Media',
    gLinkEncoder: 'G-Link Encoder',
    Delete: 'Delete',
    option: 'Select',
    tableView: 'Table View',
    calendarView: 'Calendar View',
    deviceNameIpt: 'PeerID or name',
    errRate: 'Error Rate',
    lineQuality: 'Line Quality',
    tBattery: 'T Battery',
    tFormat: 'T Format',
    tInput: 'T Input',
    rFormat: 'R Format',
    liveVideo: 'Live Video',
    runningBooking: 'Running Bookings',
    audio: 'Audio',
    left: 'L',
    right: 'R',
    capitalDelay: 'DELAY',
    capitalBit: 'BITRATE',
    quality: 'Quality',
    'en-US': 'English(United States)',
    'ja-JP': 'Japanese(Japan)',
    'pt-PT': 'Portuguese(Portugal)',
    'zh-Hans': 'Chinese(Simplified,PRC)',
    eventAlert: 'Event Alert',
    send: 'Send',
    receivers: 'Receivers',
    sources: 'Sources',
    transmission: 'Transmission',
    noTransmission: 'No transmission info',
    receiverPID: 'Receiver PID',
    sourcePID: 'Source PID',
    priority: 'Priority',
    eventName: 'Event Name',
    FolderName: 'Folder Name',
    eventTime: 'Event Time',
    location: 'Location',
    errorCodeFormartError: 'error code format error',
    livePort: 'Live Port',
    previewPort: 'Preview Port',
    description: 'Description',
    notes: 'Notes',
    errorInfo: 'Please input necessary data!',
    deleteBookingPrompt: 'Are you sure you want to delete the selected bookings?',
    log: 'Log',
    notPaired: 'Source and Receiver are not paired',
    sourceOccupied: 'Source  occupied',
    liveFailed: 'Live Failed',
    serviceClosed: 'Booking Service for this Receiver is not enabled',
    receiverOffline: 'Receiver offline',
    receiverStopped: 'Receiver stopped',
    sourceSwitched: 'Source switched manually',
    receiverStoppedManually: 'Receiver stopped manually',
    goodNight: 'Good Night',
    bookmark: 'Bookmark',
    filter: 'Filter',
    tvuPack: 'TVUPack',
    tvuAnywhere: 'TVUAnywhere',
    gridPack: 'TVU Grid-Pack',
    gridSDI: 'TVU Grid-SDI',
    receiverOccupied: 'Receiver occupied',
    titleEmpty: 'Title cannot be empty',
    durEmpty: 'Duration cannot be empty',
    sourceEmpty: 'Source cannot be empty',
    sourceSelectFirst: 'Please select a Source/SCTE first',
    unClassified: 'Unclassified',
    compose: 'Compose',
    inbox: 'Inbox',
    sent: 'Sent',
    selAll: 'Select All',
    from: 'From',
    to: 'To',
    allDevice: 'All Devices',
    now: 'Now',
    hour: 'hour ago',
    mySource: 'TVU Command Center -- Homepage',
    settingControl: 'TVU Command Center -- Setting',
    token: 'Token',
    all: 'All',
    rIsNotLiving: 'Current receiver is not living.',
    localSourceCanNotStop: 'The locally connected source cannot be stopped.',
    noCamera: 'No camera!',
    tokenPending: 'Pending',
    battery: 'Battery',
    PeerIncorrectStatus: 'The status of the Source is detected to be incorrect or the status of the Source is not obtained by Receiver.',
    prompEnsureDel: 'Are you sure want to delete selected events?',
    good: 'Good',
    bad: 'Bad',
    veryBad: 'Very bad',
    worse: 'Worse',
    rDEmpty: 'Destination cannot be empty',
    rEmpty: 'Channel cannot be empty',
    btn: 'OK',
    selectPlaceholder: 'Please Choose Device',
    sureDeleteEvent: 'Are you sure you want to stop this event?',
    minAgo: 'min ago',
    hourAgo: 'hour ago',
    sentAlert: 'Sent Alerts',
    i18n_noauthorization: 'No authorization',
    refreshInterval: 'Refresh interval (seconds):',
    coordinate: 'coordinate',
    accountExist: 'This user account already has Command Center access. Please contact TVU Support for assistance.',
    nameExist: 'The name already exists',
    nameNotExist: 'Device does not exist',
    correctLocation: 'Please select the correct location',
    noAccessApp: 'User can not access AccessApp',
    bindedDevice: 'This user had binded with this device',
    bindFail: 'bind user fail',
    removeAllFail: 'remove all fail',
    removeFail: 'remove fail',
    firstName: 'First Name',
    lastName: 'Last Name',
    nameRequired: 'First Name and Last Name cannot be empty',
    copyUserTo: 'Copy user to',
    destinationDevice: 'Destination Device',
    deleteOriginalDevice: 'Delete the original device',
    fullName: 'Enter the full PID/Name',
    newDeviceNotExit: 'New device not exist',
    Copy: 'copy',
    capitalCopy: 'Copy',
    clearFilter: 'Clear Filters',

    // share
    VirtualCloudR: 'Virtual Cloud Receiver',
    SocialAccount: 'Social Account',
    i18n_refresh: 'Refresh',
    // Source
    i18n_moreShare: 'Publish',
    i18n_loading: 'Loading~',
    // Social
    i18n_websiteType: 'Website Type',
    i18n_outputName: 'Output Name',
    i18n_yes: 'Yes',
    i18n_no: 'No',
    i18n_operate: 'Operation',
    Operation: 'Operation',
    i18n_ifSharing: 'Sharing',
    Facebook: 'Facebook',
    Periscope: 'Twitter',
    Twitter: 'Twitter',
    Twitch: 'Twitch',
    Instagram: 'Instagram',
    KuaiShou: 'KuaiShou',
    YiLive: 'Yi Live',
    Others: 'Others',
    Vimeo: 'Vimeo',
    i18n_confirm: 'OK',
    i18n_quite: 'Cancel',
    i18n_ifDelete: 'Are you sure you want to remove it?',
    i18n_deleteSuccess: 'Remove success!',
    noChart: 'Search content contains special characters, please re-enter!',
    // map
    i18n_mapFailed: 'Fail to load map, you can try to reload the page.',

    available: 'Available',
    noSource: 'Online with no source',
    viaToken: 'TVU Grid Via Token',
    globalGrid: 'Global Grid',
    alertContent: 'Please input alert content',
    iptNesInfo: 'Please input necessary information!',
    addReceiver: 'Please add recipient for the message.',
    sourceType: 'Source type',
    format: 'Format',
    error: 'Error',
    errorTips: 'Error',
    batteryVal: 'Battery',
    slot: 'Slot',
    metadata: 'Metadata',
    noMetadata: 'No Metadata info',
    tokenCode: 'Token Code',
    tokenCodeTips: 'Enter the token code',
    self: 'Introduce Yourself',
    selfTips: 'Who are you (Optional) ?',
    chooseRecevice: 'Select which Receivers the Token TVU Grid sources should be paired to',
    chooseReceviceTips: 'Enter the PeerID or name to search',
    /* home lang */
    home_EnterReceiverNamePeerID: 'Enter Receiver Name/PeerID',
    home_Live: 'Live',
    live_OnHold: 'Live on hold',
    home_Online: 'Online',
    home_clickOfflineR: 'This device is offline.',

    // Setting
    running: 'Running',
    theSameDevice: 'The current device is already exists',
    wait2Second: 'Click it 2 seconds later',
    removeIt: 'Are you sure you want to remove it',
    createAccess: 'Create an API Access',
    editAccess: 'Edit API Access',
    company: 'Company',
    accessSearch: 'Name / Email / AppKey / AppSecret',
    email: 'Email',
    searchPlaceholder: 'Email / First Name / Last Name',
    importUsers: 'Import Accounts',
    importUsersTip: 'Upload an Excel file (.xlsx/.xls) to batch import users. Please use the template below.',
    downloadTemplate: 'Download Template',
    dropFileHere: 'Drop file here or click to upload',
    importResult: 'Import Result',
    failedDetails: 'Failed Details',
    skipped: 'Skipped',
    skippedExist: 'Skipped (already exist)',
    importAllSuccess: 'You have successfully imported {0} {1}.',
    importWithFail: 'You have successfully imported {0} {1}, and {2}.',
    importFailedText: '{0} failed',
    importWithSkipped: 'You have successfully imported {0} {1}, {2}.',
    importSkippedText: '{0} of which already exist',
    importAllFailed: 'Import failed, {0}.',
    importAllExist: '{0} {1} already exist.',
    importWithFailAndSkipped: 'You have successfully imported {0} {1}, {2} and {3}.',
    importAlreadyExistText: '{0} already exist',
    accountSingular: 'account',
    accountPlural: 'accounts',
    importParseError: 'The document does not meet the requirements and cannot be parsed. Please use the template and try again.',
    emailOrId: 'Full matching of accounts/Full PID',
    role: 'Role',
    accountType: 'Account Type',
    appKey: 'AppKey',
    appSecret: 'AppSecret',
    whiteIP: 'WhiteIP',
    bearerToken: 'BearerToken',
    bearerTokenSupport: 'Support',
    bearerTokenNotSupport: 'Not support',
    operationEmail: 'Operation Account',
    emailEmpty: 'Email cannot be empty',
    companyEmpty: 'Name cannot be empty',
    emailformat: 'Email format is incorrect!',
    emailAddress: 'Please input a correct Email address.',
    ExternalSource: 'External Source',
    Account: 'Account',
    relationHistory: 'Account Relation History',
    AccessAPP: 'API Access',
    SalesForce: 'Sales Force',
    FileServer: 'File Server',
    Device: 'Device',
    MenuList: 'Menu List',
    set_name: 'The name cannot be empty!',
    set_nameLength: 'Please input minimum 3 characters.',
    set_url: 'The URL cannot be empty',
    ipFormatError: 'IP format error',
    userCreation: 'User Creation',
    userEditing: 'Modify', // CC-2180: 弹窗同时承载 email/姓名/权限编辑，不再自称 Modify Permission [Claude Code]
    emailNotOwnUser: 'You can only modify the email of users under your own account.', // CC-2180 错误码 81003108 [Claude Code]
    choice: 'Please Select',
    inputLegitEmail: 'Please input a legit Email address!',
    inputUesr: 'Please select owner',
    inputPassword: 'Please input password!',
    inputPhone: 'Input error. Only +, - and numbers are allowed in a phone number. E.g. +1-541-754-3010',
    admin: 'Admin',
    user: 'User',
    phone: 'Phone',
    remark: 'Remark',
    instanceType: 'Instance Type',
    instanceStorage: 'Storage',
    storageTips: 'Extra charge for storage above 32GB',
    modifyPermission: 'Modify',
    nodeactivate: 'Inactive',
    yesactivate: 'Active',
    activate: 'Activate',
    deactivate: 'Deactivate',
    inactive: 'Inactive',
    active: 'Active',
    deleteRole: 'Delete Role',
    addRole: 'Add Role',
    degradeRole: 'Degrade Account',
    increaseRole: 'Increase Account',
    password: 'Password',
    permission: 'Permission',
    loginMethod: 'Login Method',
    loginSSO: 'SSO',
    licensedFeature: 'Licensed Feature',
    licensedFeatureReport: 'Licensed Feature Report',
    owner: 'Owner',
    subscriber: 'Subscriber',
    input3Character: 'Please input at least 3 characters to filter',
    availableDevice: 'Available Device',
    bindingDevice: 'Binding Device',
    unknow: 'Unknown',
    salesforceAccount: 'Salesforce Account',
    uername: 'Username',
    deviceType: 'Device Type',
    relationManagement: 'Relation Management',
    relationManagementWarning: '*Warning: when removing a receiver from an account, the existing token pairings with the receiver will also be removed.',
    confirmRemoveAllBindDevice: 'Are you sure you want to remove all bound devices from this account? The existing token pairings with the receivers will also be removed.',
    removeAllBindProcessing: 'Removing all bound devices is still processing in the background. Please refresh later to check the result.',
    removeAllBindRunningTip: 'Removing devices under this account, please do not close the dialog.',
    bindingAccount: 'Binding Account',
    changeDevice: 'Change Device Property:',
    showPaired: 'Show the paired devices',
    automatic: 'Automatic',
    manual: 'Manual',
    noPosition: 'No Location',
    userInfo: 'User Information',
    GEOLocation: 'Location',
    LastOnlineTime: 'Last Online',
    peerID: 'PeerID',
    function: 'Function',
    availableFunction: 'Available Function',
    enabledFunction: 'Enabled Function',
    editApi: 'Edit API Function',
    aipFunction: 'API Function',
    addWhiteIp: 'Add WhiteIP',
    existIp: 'This IP already exists',
    whiteIPList: 'WhiteIPList',
    accessControl: 'Access Control',
    Licensed: 'Licensed Feature Report',
    startTimeText: 'Start Time',
    endTimeText: 'End Time',
    requestId: 'Request Id',
    userId: 'User Id',
    relationAccount: 'Relation Account',
    relationAccountId: 'Relation Account Id',
    param: 'Param',
    operationType: 'Operation Type',
    excelAll: 'Excel All',
    decivesAssignedAnotherUser: 'One or more devices have been assigned to another user. Would you like to continue?',
    sameIp: 'The same IP exists',
    activateTips: 'Are you sure you want to Active this user?',
    deactivateTips: 'Are you sure you want to Inactive this user?',
    monitorUserTips: 'Are you sure you want to View this user?',
    gotoSupportTips: 'Are you sure you want to return to the support account?',
    editDevice: 'Edit Device Name',
    removelAllUsers: 'Remove all users',
    removeUsers: 'Remove users',
    removelUsers: 'Remove this users',
    ifRemoveUsers: 'Do you want to remove all users?',
    ifRemoveUser: 'Do you want to remove this user?',
    userAccountTips: 'please select user account',
    setlocationTips: 'Please select the location below or enter the location',
    bookmarkNameTips: 'Bookmark name exist',
    connotDelete: 'This source has already been scheduled by the Booking Service. Please remove the existing bookings to proceed.',
    useExist: 'User not exist',
    anotherSourceEdit: 'Another source is being edited',
    completeEditOperation: 'Please complete the editing operation first',
    bookmarkNameRequired: 'Bookmark name cannot be empty.',
    companyExist: 'company name is exist!',
    extLiving: 'Device is living',
    RPSEncoder: 'RPS Encoder',
    RPSLink: 'RPS Link',
    RPSDecoder: 'RPS Decoder',
    set_name_space: 'Space is not allowed in device names',
    accountEmpty: 'account is not empty',
    moduleNotFound: 'Module Not Found',
    idNotFound: 'Id not found',
    addUser: 'Add User',
    DeviceChangeLog: 'DeviceChangeLog',
    clear: 'clear',
    passwordLength: 'Password is at least 6 digits',
    TestInstance: 'Test Instance',
    startInstance: 'Start Instance',
    runInstance: 'Instance is running',
    starting: 'Starting',
    ending: 'Ending',
    noPairR: 'not pair R!',
    GroupManage: 'Group',
    connectedCC: 'Connected to CC',
    getSessionFailed: 'get session failed',
    waitMinutes: 'Starting a WebR may take approximately 3 - 5 minutes',
    selectVaildTime: 'Please select a vaild time',
    deviceFeature: 'Device Feature',
    startDate: 'Start Date',
    startUpDate: 'Start-up time',
    endDate: 'End Date',
    endUpDate: 'Shut-down time',
    explainA: 'To extend these features, please contact',
    explainB: 'your sales representative or TVU Support',
    reloadTips: 'Account reloading may take some time to finish. Please be aware.',
    addReloadTips: 'Add missing sources that are paired with the receivers.',
    removeReloadTips1: 'Remove sources that are not paired with any receivers. ',
    removeReloadTips2: 'Proceed cautiously with RPS/Router/Producer accounts.',
    addEmail: 'Add Email',
    // Pagination
    i18n_first: 'First page',
    i18n_pre: 'Previous page',
    i18n_next: 'Next page',
    i18n_last: 'The last page',
    i18n_jump: 'Redirect to',
    i18n_pageRange: '{start}-{end} of {total}',

    // token
    autoApprove: 'automatically approve all incoming Token requests',
    editDeviceBtn: 'Edit Device',
    expireTime: 'Expire time:',
    gridReceiver: 'TVU Grid Source',
    createToken: 'Create Token',
    editToken: 'Edit Token',
    tokenName: 'Token Name',
    tokenType: 'Token Type',
    expiration: 'Expiration',
    availableList: 'Available List',
    saleAvailableList: 'Available List',
    selectedList: 'Selected List',
    pid: 'PID',
    deviceName: 'Device Name',
    add: 'Add',
    remove: 'Remove',
    addAll: 'All',
    removeAll: 'All',
    iptTokenName: 'Give Token a name',
    iptExpiration: 'Choose an expired time',
    iptAvailable: 'Enter 3 characters minimum',
    peeridOrName: 'PeerID or name',
    qrPromp: 'Share the QR or token code with others for pairing with the following devices.',
    receiverList: 'Receiver List',
    snedCodeToEmail: 'Send Code To Email',
    ensureDelete: 'All devices paired are going to be lost!',
    snedCodeTo: 'To',
    emialAds: 'Email address',
    bookmarkName: 'Bookmark name',
    createBookmark: 'Create Bookmark',
    includeInBokmk: 'Include in bookmark',
    bookmarkBars: 'Bookmarks Bar',
    deleteBookmark: 'Do you want to delete this bookmark?',
    addDevice: 'Add Device',
    move: 'Move',
    moveDeviceTo: 'Move Device to',
    copyDeviceTo: 'Duplicate Device to',
    success: 'Success',
    chooseBookmark: 'Please choose one bookmark',
    sureDeleteDevice: 'Are you sure you want to delete these devices from this bookmark?',
    relationMang: 'Relation Management',
    external: 'External',
    local: 'Local',
    'Https External': 'Https External',
    'Https Local': 'Https Local',
    portValid: 'The port value cannot be null and input port between 1 ~ 65535',
    setIPAndPort: 'You have some options not set, please complete them',
    fileServerID: 'File Server ID',
    modules: 'Modules',
    ip: 'IP',
    monitor: 'Monitor',
    worker: 'Worker',
    createFileServer: 'Create a File Server',
    saveIdPort: 'SlaveId Port',
    saveId: 'SlaveId',
    port: 'Port',
    salesName: 'Sales Name',
    region: 'Region',
    salesAccount: 'Sales Account',
    salesForceName: 'Sales Force Name',
    englishText: 'English Text',
    chineseText: 'Chinese Text',
    pageMark: 'Page Mark',
    Aspect: 'Aspect',
    LastFrame: 'Last Frame',
    LastFrameSeconds: 'Last Frame lasts for N seconds',
    AudioChannels: 'Audio channels',
    // SMPTE RiverMax Setting
    ST2022_7: 'ST2022-7',
    ST2110: 'ST2110',
    SFP: 'SFP',
    IP: 'IP',
    VideoFormat: 'Video Format',
    PleaseSelect: 'Please Select',
    SDR: 'SDR',
    HLG: 'HLG',
    HDR10: 'HDR10',
    AdvancedEllipsis: 'Advanced...',
    VideoIP: 'Video IP',
    RemotePort: 'Remote Port',
    RTPPayloadType: 'RTP Payload Type',
    From96To127: 'From 96 to 127',
    TTL: 'TTL',
    From1To255: 'From 1 to 255',
    AudioIP: 'Audio IP',
    PacketTime: 'Packet Time',
    AncillaryDataIP: 'Ancillary Data IP',
    SourceIP: 'Source IP',
    PTPGMID: 'PTP GM ID',
    Input: 'Input',
    Output12: 'Output-12db audio while standing by',
    AsfFrameFroze: 'AsfFrameFroze',
    Encoder: 'Encoder',
    /* ---- RPS Encoder / HDR / Chroma (rpsv3-131-yuv422-hdr-chroma) ---- */
    HDRHLG: 'HDR/HLG',
    HDRHLGAutoFor10bit: 'Auto for 10-bit',
    HDRHLGHlgFor10bit: 'HLG for 10-bit',
    HDRHLGWithoutHDRHLG: '10-bit without HDR/HLG',
    HDRHLGForced8bit: 'Forced 8-bit',
    ChromaSubsampling: 'Chroma Subsampling',
    ChromaSourceNotSupport422: 'Source does not support 4:2:2',
    ChromaParamInvalid: 'Invalid parameter, setting failed',
    // RPSV3-170: 硬件不支持 422 10bit 时，4:2:2 禁用态提示文案 [Claude Code]
    ChromaHwNotSupport422: 'This hardware does not support 4:2:2 (422 10-bit)',
    // RPSV3-170: HDR/HLG 三个 10-bit 选项在硬件不支持时的禁用原因（el-option title 属性）[Claude Code]
    Chroma10bitHwNotSupport: '10-bit is not available (hardware not supported)',
    // RPSV3-136: 4:2:2 与 Forced 8-bit 互斥的双向提示（4:2:2 禁用因 Forced 8-bit / Forced 8-bit 禁用因 4:2:2）[Claude Code]
    Chroma422Requires10bit: '4:2:2 requires 10-bit',
    // 决策 A: 非法态（选中值落在禁止集）警告图标 tooltip [Claude Code]
    ChromaIllegalComboWarning: 'Current configuration is not supported by this hardware, please switch to a valid combination',
    EncodeWritePartialFail: 'Some encoder paths failed to apply the setting. Please retry.',
    RPSReadInfoFail: 'Failed to read device status. Please retry.',
    Resolution: 'Resolution',
    ResolutionChangeInterrupt: 'Switching the resolution will briefly interrupt the return video. Do you want to switch now?',
    SwitchAction: 'Switch',
    Port: 'Port',
    VBitrate: 'VBitrate',
    ABitrate: 'ABitrate',
    AChannel: 'AChannel',
    Channel: 'Channel',
    SetMediaDevice: 'Set Media Device',
    Microphone: 'Microphone',
    Speaker: 'Speaker',
    IPAndPort: 'IP and Port Mapping',
    External: 'External',
    Local: 'Local',
    WebPort: 'Web Port',
    StreamPort: 'Stream Port',
    AutoConvert: 'Auto convert to',
    VisionTag: 'Vision Tag Settings',
    Language: 'Language',
    Landmarks: 'Landmarks',
    Celebrities: 'Celebrities',
    Adult: 'Adult',
    Faces: 'Faces',
    VisualFeatures: 'Visual Features',
    Settings: 'Settings',
    Encapsulation: 'Encapsulation',
    Framesrate: 'Frame rate',
    TimeElapsed: 'Time Elapsed',
    EncoderPid: 'Encoder Pid',
    TimeLock: 'Time Lock',
    GOP: 'GOP',
    FileSize: 'File Size',
    StartedAt: 'Started At',
    Deinterlace: 'Deinterlace',
    ProgramID: 'Program ID',
    Samplerate: 'Samplerate',
    OutputPath: 'Output Path',
    FileName: 'File Name',
    FullName: 'Full Name',
    Status: 'Status',
    VideoBitrate: 'Video Bitrate',
    FPS: 'FPS',
    show: 'Show',
    other: 'Other',
    tvucc: 'TVUCC',
    hide: 'Hide',
    editMenu: 'Edit Menu',
    addMenu: 'Add Menu',
    menuSort: 'Sort',
    dragSort: 'Drag menus below to adjust their order',
    sureRemove: 'Are you sure you want to remove it?',
    isModifyBookmarkName: 'Would you like to modify this bookmark name?',
    menu: 'Menu',
    orderNo: 'OrderNo',
    feature: 'Feature',
    menuError: 'The menu cannot be empty',
    enNameError: 'The enName cannot be empty',
    cnNameError: 'The cnName cannot be empty',
    dataMarkError: 'The dataMark cannot be empty',
    typeError: 'The type cannot be empty',
    enableError: 'The enable cannot be empty',
    remarkError: 'The remark cannot be empty',
    orderNoError: 'The orderNo cannot be empty and can only be a number',
    adminAutoOwnError: 'Admin Auto Own cannot be empty and can only be a number',
    FeatureList: 'Feature List',
    MailTemplate: 'Mail Template',
    adminAutoOwn: 'Admin Auto Own',
    addFeature: 'Add Feature',
    editFeature: 'Edit Feature',
    setTranscriber: 'Transcriber Settings',
    transcriberDelay: 'Transcriber Delay(s)',
    video: 'Video',
    languageSelection: 'Language Selection',
    saveSRT: 'Save SRT Files To',
    activatedSystem: 'Actived System',
    scheduledTime: 'Scheduled Time',
    applyBtn: 'Apply',
    displayLines: 'Display Lines',
    charactersPerLine: 'Characters Per Line',
    ClearUppercase: 'Clear',
    captionType: 'Caption Type',
    Profranity: 'Profanity',
    autoMuteWords: 'Auto Mute Words',
    Timed: 'Timed',
    enableTVUTranscriber: 'Enable TVU Transcriber',
    bitrateDelay: 'Please input number between {0} ~ {1}',
    Enabled: 'Enabled',
    showMore: 'Show More',
    deviceList: 'Device List',
    accepted: 'Accepted',
    denied: 'Denied',
    joinTime: 'Join Time',
    introduction: 'Introduction',
    expired: 'expired',
    rejected: 'Denied',
    setExpired: 'Mark as expired',
    deny: 'Deny',
    accept: 'Accept',
    existName: 'Token name already exists',
    tokenNameEmpty: 'Token Name is required',
    expiredTimeEmpty: 'Time cannot be empty',
    shareTo: 'Share to',
    userAccount: 'User account',
    members: 'members',
    notSpecialChar: 'The device name cannot contain special characters',
    // Start && stop live code
    SourceNotBelongToUser: 'Source not belong to user.',
    ReceiverNotBelongToUser: 'Receiver not belong to user.',
    UserRoleNoFeature: 'No permission.Please contact your Command Center account administrator or TVU Support for help.',
    receiverOnline: 'Receiver online',
    GivenPeerNotSelected: 'Parameter error',
    featuresEffect: 'The change of features will take effect after restart',
    enditFailed: 'Edited failed',
    requestFailed: 'Request failed',
    setLocationTips: 'Please Set Receiver Location',
    invalidUrl: 'Invalid URL',
    supportManager: 'Support Manager',
    systemAdmin: 'System Admin',
    featureError: 'The feature cannot be empty',
    autoOwnError: 'The autoOwn cannot be empty',
    urlError: 'The url cannot be empty',
    accessPage: 'Access to Pages',
    account: 'Account',
    support: 'Support',
    control: 'Control',
    autoOwn: 'AutoOwn',
    currentRLiveSourceNotBelongToUser: 'Receiver current living source not belong to user',
    isBooking: 'The receiver is executing a reservation event',
    mailAddrTips: 'Please input a valid email address',
    emailTips: 'What do you want to say?',
    operationFailure: 'Operation failure',
    noTokenPrompt: 'Token is a more efficient way to facilitate the pairing of TVU devices',
    operationFailed: 'Operation failed, please try again!',
    tokenItems: 'Total Tokens',
    searchDevicePrompt: 'Please input at least 3 characters to filter.',
    timeError: 'The expiration time is less than the current time',
    type: 'Type',
    bitrate: 'Bitrate',
    receiverNotConnect: 'Receiver not connect',
    notHaveStartauthor: 'No Start Live permission.Please contact your Command Center account administrator or TVU Support for help.',
    notHaveStoptauthor: 'No stop live permission.Please contact your Command Center account administrator or TVU Support for help.',
    notHaveVoipauthor: 'VoIP access not permitted. Please contact your administrator or TVU support for assistance.',
    // My Receiver Page
    rinputDescrible: 'Enter memo',
    sourceFrom: 'Source From',
    newMyRecevierInputTitle: 'Video or Destination',
    newMyRecevierSort: 'Sort by status',
    receiverDataIsEmpty: 'Receiver data empty',
    recevierMyFavorite: 'My Favorite',
    addFavoriteSuccess: 'Add to favorite success.',
    EnterSourceNamePeerID: 'Source Name/PeerID/URL',
    notSupportFunction: 'Not support this operation',
    // Mail Template
    params: 'Params',
    TimeRemaining: 'Time Remaining:',
    StorageRemaining: 'Storage Remaining:',
    createMailTemplate: 'Create Mail Template',
    editMailTemplate: 'Edit Mail Template',
    emptyURLCheck: 'Please enter template URL',
    validURLCheck: 'Please enter the template URL that exists and can be accessed by the service.',
    emptyNameCheck: 'Please enter template name',
    emptyTypeCheck: 'Please select template type',
    emptyParamsCheck: 'Please select template params',
    tokenExpired: 'Expired',
    invalidTime: 'Invalid time',
    uploadExcel: 'Export to Excel',
    uploadExcelAll: 'Export All',
    // new home
    dynamicsorting: 'Dynamic Sorting',
    serverFailed: 'Server exception',
    modeSwitching: 'Mode switching, please operate later',
    anywhereTimeout: 'Anywhere connection timed out, please check device settings or contact technical support',

    // new multiview
    cannotSwitchSplitScreenMode: 'Your current video number is larger than you want to switch the split-screen mode, can not switch!',
    rVerionNeedV56Above: 'The receiver software requires to be v5.6 or above.',
    showInfo: 'Show Info',
    audioMeter: 'Audio meter',
    AddToCall: 'Add to call',
    startToCall: 'Start the call',
    selectMonitorSelectCall: 'Only TVUPack and TVU Anywhere support VoIP.',
    selectObjCall: 'Please select which you want to establish the voice call with.',
    setVideoFeedbackTrueViewVideo: 'Video preview is disabled. Please enable it or contact TVU support for assistance.',
    setVideoFeedbackTrueViewVideoMoreLive: 'Max number of previews - 5 has been reached. Please turn off other preview windows first.',
    continueCall: 'Continue call',
    interruptAllCall: 'Would you like to end the active calls?',
    interruptAll: 'Hang up',
    changeOwner: 'Change Owner',
    belongTo: 'Belong to',
    alreadyBelong: 'Customer user already belong to admin user',
    startTimeLessThanCurTime: 'Start time is less than the current time',
    stopTimeLessThanCurTime: 'End time is less than the current time',
    selectData: 'Select date and time',
    enterStartTime: 'Please enter the start time',
    enterEndTime: 'Please enter the end time',
    enterDescription: 'Please enter the event description',
    selectOwner: 'Please select an administrator account',
    switchToWeek: 'Please switch to the week view',
    extMustSetUrl: 'The ext OR sdiin source must set url',
    magnifying: 'Zoom +',
    faildCallTpcModifyName: 'failed to call TPC to modify name!',
    scte: 'scte',
    scteCaptial: 'SCTE',
    trigger: 'Trigger',
    addScte: 'Add SCTE',
    spliceType: 'Splice Type',
    prerollTime: 'Preroll Time',
    nameEmpty: 'Name cannot be empty',
    scteName: 'SCTE Name',
    bookingEvents: 'Booking Events',
    runningEvents: 'Running Events',
    pastEvents: 'Past Events',
    createTime: 'Create Time',
    deviceSourceScte: 'Source',
    Parameters: 'Parameters',
    file: 'File',
    addfile: 'Add File',
    addFolder: 'Add Folder',
    Folder: 'Folder',
    selectAFolder: 'Select a folder',
    addMedia: 'Add Media',
    addvideo: 'Add Local Video',
    editfile: 'Edit File',
    editEmail: 'Edit Email',
    fileName: 'File name',
    bookingImportFile: 'Import Excel or CSV files to add in batches.',
    bookingImportFileTemp: 'View file template.',
    search: 'Search',
    bookingChannel: 'Channel',
    bookingDeleteFail: 'Some file is being used by an event and cannot be deleted',
    bookingEditFail: 'Some events are using this file and cannot be modified',
    durationEmpty: 'Duration cannot be empty.',
    durationType: 'Duration need enter a positive integer',
    nameIsExist: 'The name already exist ',
    durationUnit: '( s )',
    upload: 'Upload',
    proccessing: 'Processing...',
    uploadVideoLocal: 'Upload local video file',
    uploadHasSame: 'The file you selected has already been uploaded',
    selectAVideo: 'Please select a video to add.',
    videoExist: 'Video already exists',
    fileNeedType: 'Upload files can only be in xls, xlsx, csv format!',
    videoNeedType: 'Upload videos can only be in ts,rm,rmvb,wmv,wtv,avi,3gp,mkv,mpg,video/mpeg,video/mp4,mov format!',
    noDevice: 'No Device',
    noConnection: 'No Connection',
    readonly: "video type or scte type can't change end time",
    sctePrerollTime: 'PrerollTime length can not greater than 5',

    // alert
    offlined: 'went offline',
    onlined: 'came online',
    startLiveTip: 'started live transmission',
    stopLiveTip: 'stopped live transmission',
    noAvailable: 'N / A',

    // setting
    deviceNameBytes: 'Device name can not exceed 15 bytes.',
    // CC-2288: RPS 子设备改名——12 字节管的是【剔掉尾部 _NN 通道序号后的基名】，不是整串输入 [Claude Code]
    rpsDeviceNameBytes: 'Device name (excluding the _NN channel suffix) can not exceed 12 bytes.',
    instanceId: 'Instance id',
    rId: 'Receiver ID',
    Ip: 'IP',
    creater: 'Starter',
    stopR: 'Stop Receiver',
    stopTime: 'Shutdown time',
    unAssigned: 'Unassigned',
    shutdownP: 'Closer',
    Shutdown: 'Shut-down',
    launchTime: 'Launch',
    ShutdownTime: 'Shut-down Time',
    scheduleTime: 'Schedule Time',
    scheduleShutdownTime: 'Schedule Shut-down Time',
    scheduleStartTime: 'schedule start-up time',
    usageType: 'Usage Type',
    assignAdmin: 'Assign to the Customer Account',
    selectUsageType: 'Please select the usage type',
    selectInstanceType: 'Please select the instance type',
    startUpCloudR: 'Start-up Cloud Receiver',
    ClosedBySystem: 'Closed By System',
    ClosedBySupport: 'Closed By Support',
    ClosedCloudR: 'Closed',
    ScheduleFeature: 'Scheduled feature',
    canUseArea: 'Available area',
    selectArea: 'Please select a region you want to start',
    selectNumOfMachine: 'Please select a number of Rs required by the virtual machine you want to start',
    selectProject: 'Please select project type',
    noRegion: 'There is no available region under the current type, please select other',
    connectTpcFail: 'Connect TPC failed',
    connectInstanceFail: 'Connect Instance-service failed',
    getRegionFail: 'Get active region failed',
    createInsFail: 'Create instance failed',
    shutdownInsFail: 'Shutdown instance failed',
    userInsnull: 'User instance is not exist',
    userInsreadyCLose: 'User instance already closed',
    userExist: 'User already exist in Command Center',
    confirmShutDown: 'Are you sure you want to shut it down?',
    confirmDeleteSchedule: 'Are you sure you want to delete this schedule Cloud Receiver?',
    virtualRDes: 'Virtual cloud Receiver',
    needRNum: 'Number of Rs required by the virtual machine',
    emailNotice: 'Email Notification When Cloud Receiver Starts',
    projectType: 'Cloud Receiver Type',
    replaceEmail: 'Replace Email',
    // CC-2180 v3: 改 email 前的二次确认文案，{old}/{new} 为命名占位符，用法同 slaveRenameNotAllowed 的 {pid} [Claude Code]
    confirmChangeEmail: 'Change email from {old} to {new}? The user will only be able to sign in with the new email.',
    delelteUser: 'Delete',
    editDeviceNameFaild: 'Edit T device name is peer service failed',
    // WR-318 device rename error codes
    slaveRenameNotAllowed: 'This device is a slave device and cannot be renamed directly. Please edit its master device (PID: {pid}).',
    renameParamError: 'Request parameter error, please try again',
    renameNoRights: 'No permission or the device does not exist',
    deviceNameValidateFailed: 'Device name validation failed',
    renameRetryLater: 'Rename failed, please try again later',
    deviceOfflineRetry: 'Device is offline or not registered, please try again later',
    deviceTypeError: 'Device type error, please contact support',
    addNewBookmark: 'Add to a new bookmark',
    includeInBookmark: 'include in My Bookmark',
    bookmarksBar: 'Please Select Bookmarks Bar',
    offTime: 'Off Time',
    offTimeNotEmpty: 'shut-down time cannot be empty',
    hebdomad: 'Hebdomad',
    thirtyDays: 'Thirty Days',
    deviceShutdownDate: 'The equipment shutdown time is',
    receiverPidOrName: 'Receiver PeerID or name',
    gridOwner: 'TVU Grid Owner',
    createEvent: 'Create Event',
    Reload: 'Reload',
    reloadConfirm: 'Reloading receivers and sources of this account will need some time. Do you still want to continue?',
    reloadPageConfirm: 'Reloading receivers and sources of current page will need some time. Do you still want to continue?',
    deviceReloadConfirm: 'Reloading this receiver will need some time. Do you still want to continue?',
    deviceReloadPageConfirm: 'Reloading the receivers of current page will need some time. Do you still want to continue?',
    switchDeviceSourcesOld: 'Switch to Previous Auth Method to Allow Authorizing Sources',
    switchDeviceSourcesNew: 'Switch to New Receiver-centric Authorization',

    autoType: 'Mode',
    groupName: 'Group Name',
    deviceStatus: 'Device Status',
    address: 'Address',
    // 定制化CC
    searchGroup: 'Search Group',
    defaultGroup: 'Is Default',
    addGroup: 'Add Group',
    inputGroup: 'Please input group name',
    editGroup: 'Edit Group',
    set_groupName: 'The group name cannot be empty',
    changeGroup: 'Change Group',
    noGroup: 'Please select a group',

    groupExist: 'Group exist',
    defaultNotDelete: 'default group cannot delete',

    existDeviceGroup: 'Group exist device, cannot delete',
    eventNoExist: 'Event not exist',
    sourceNoExist: "Source doesn't exist",
    noIdleChannel: 'There is no available live channel',
    groupNotExist: "Group doesn't exist",
    userNoGroup: 'Group not belong user',
    deviceNotT: 'Device not T',
    registFailed: 'Register device failed',
    accountSharing: 'This account is streaming now',
    accountNoSharing: "Current account doesn't sharing",
    systemError: 'System error',
    pushFailed: 'Share video failed',
    stopPushFailed: 'Stop share video failed',
    // 其他
    shareToeknSelect: 'Select',
    shareBy: 'Shared by',

    waitCalled: 'Waiting UGC',
    channelOccupied: 'Exist channel occupied',

    // multiview plus
    addTo: 'Add to',
    copySuccess: 'Copy Success',
    deleteSuccess: 'Delete Success',
    userNotExist: 'User not exist in CC',
    emailExistInCC: 'Email exist in CC',
    emailExistInDB: 'Email exist in dashboard',
    USUpdateFailed: 'UserService update email failed',
    DBUpdateFailed: 'Dashboard update email failed',
    Enter: 'Enter',
    dragAndDrop: 'Drag and drop to sort',
    overMax: 'over the maximum quantity',
    loadMore: 'Load more',
    agreement: 'Agreement',
    lastLogin: 'Last Login',
    goWebR: 'Go To WebR',
    delayRang: 'Delay input rang: Only can be number, from 0.5s to 50s',
    overDevice: 'layout less than the number of device',
    tcpReportCount: 'Heartbeat',

    thumbnail: 'Thumbnails',
    liveBitrate: 'Live Bitrate',
    latency: 'Latency',
    selectBookmark: 'Please select a bookmark',
    goLive: 'Go Live',
    largeSize: 'Large',
    mediumSize: 'Medium',
    smallSize: 'Small',
    typeVal: 'Type',
    workspaceName: 'workspace name',
    nameLessThan: 'The name length is less than or equal to',
    thumbnailObj: 'Thumbnail',
    second: 'sec',
    sourceNoHaveR: 'There is no R available to change source',
    GLink: 'GLink',
    RTIL: 'RTIL',
    voipStart: 'VoIP Start With Live',
    RestartService: 'Restart Service',
    Connectivity: 'Connectivity',
    cardName: 'Card Name:',
    inputFormat: 'Input Format:',
    outputFormat: 'Output Format:',
    inOutFor: 'In/Out',
    inputFor: 'InFormat',
    outputFor: 'OutFormat',
    tranSmission: 'Transmission Parameters',
    durationTime: 'The end time can only be {time} minutes longer than the start time',
    modeTypeEmpty: 'mode cannot be empty',
    liveDontOption: 'The live operation does not support this operation',
    offSourNotReal: 'Offline devices can only select history mode',
    networkBad: 'The network is not good, please refresh the browser',
    nameExit: 'Duplicate name',
    creatName: 'Account email cannot use @tvunetworks.com',
    Preference: 'Preference',
    stopLiveConfirm: 'Are you sure you want to stop this live transmission?',
    stopLiveCheck: "Don't remind me next time",
    preferenceTitle: 'Transmission',
    stopAlertMid: 'Require confirmation when stopping a live transmission',
    keepLiveOnHold: 'Show “Live on Hold” status when a live device temporarily goes offline from a receiver',
    stopAlertRight: 'Stop a live transmission',
    startAlertMid: 'Start a live transmission',
    showLocation: 'Show Geolocation over Thumbnails',
    rightAlert: 'Allow Pop-up Notification',
    alertRight: 'New message alert for the Alert page',
    accountURL: 'Account/URL',

    // user behavior
    UserBehavior: 'Operation Log',
    ubcc: 'Command Center',
    ubpp: 'Producer',
    ubchannel: 'Channel',
    ubnodata: 'No Data',
    ubtimeOut: 'Request timed out.',
    operationDescription: 'Operation Description',
    operationParams: 'Operation Params',
    operationTime: 'Operation Time',
    localTime: 'Local Time',
    UTCTime: 'UTC Time',
    userAgent: 'Browser Information',
    ubemailPlace: 'Email (Separate searches with “,”)',
    ubAccept: 'accepted',
    ubRejected: 'rejected',
    ubDeleted: 'deleted',
    ubStartLive: 'Start live',
    ubStopLive: 'Stop live',
    ubSetDelayAndBitrate: 'Set delay and bitrate',
    ubSetIPAndPort: 'Set IP and Port Mapping',
    ubSetSDIoutput: 'Set SDI output',
    ubShare: 'Share',
    ubStopShare: 'Stop share',
    ubDownloadRecord: 'Download record',
    ubEditMemo: 'Edit memo',
    ubRequestToken: 'Request Token',
    ubAcceptRequest: 'Accept request',
    ubEditDeviceName: 'Edit device name',
    ubEditToken: 'Create Token',
    ubSendEmail: 'Send email',
    ubSetDeviceLocation: 'Set device location',
    ubdStartLive: 'Source (XXX) has started live with receiver (XXX)',
    ubdStopLive: 'Source  has stopped live with receiver (XXX)',
    ubdSetDelayAndBitrate: 'Receiver (XXX) has set delay to XXX s and bitrate to XXX kb/s at page XXX',
    ubdSetIPAndPort: 'Set the IP and port of receiver "XXX"',
    ubdSetSDIoutput: 'Set the SDI output of receiver "XXX"',
    ubdShare: 'Receiver (XXX) has shared the live stream to XXX by XXX: resolution XXX bitrate XXX',
    ubdStopShare: 'Receiver (XXX) has stopped live streaming to XXX by XXX.',
    ubdDownloadRecord: 'Receiver (XXX) has downloaded file XXX',
    ubdEditMemo: 'Device (XXX) has been added alias XXX',
    ubdAcceptRequest: 'TVUAnywhere (XXX) token pairing request has been ',
    ubdRequestToken: 'TVUAnywhere (XXX) has made a pairing request by scanning the token code XXX',
    ubdEditDeviceName: 'Device (XXX) has been renamed to XXX',
    ubdEditToken: 'Token XXX has been changed to: Expiration time XXX. Included devices XXX',
    ubdSendEmail: 'Token XXX has been emailed to XXX',
    ubdSetDeviceLocation: 'Device (XXX) has been set new location to XXX',

    All: 'All',
    Receiver: 'Receiver',
    pack: 'TVUPack',
    anywhere: 'TVUAnywhere',
    gridSdi: 'TVU Grid-SDI',

    // 新增anywhere
    manPanTitle1: 'Drag the mouse to the left video area',
    manPanTitle2: 'to adjust the position of the character on the screen',
    autoPanTitle1: 'Automatically recognize faces',
    autoPanTitle2: 'keep people The object is always in the center of the screen',
    autoSelectQuality: 'Auto',
    detailTemp: 'Temp',
    detailUsage: 'Usage',
    // profile
    profile: 'profile',
    OpenPath: 'Open Path',
    enterID: 'Please enter program id',
    selectProfile: 'Please select profile',
    ProfileAdd: 'Add',
    ProfileBack: 'Back',
    ProfileName: 'Profile Name',
    SetEncoderFail: 'Set Encoder Model Fail',
    ProgrameNum: 'Program ID can only be numbers',
    ConfirmRecording: 'Do you want to delete this recording setting profile?',
    RecordingPrompt: 'Prompt',
    ProfileNameMust: 'Please input Profile name',
    EditSuccess: 'Edit Success',
    RestartSuccess: 'Restart Success',
    CreateSuccess: 'Create Success',
    SampleRate: 'Sample Rate',
    Tune: 'Tune',
    AudioEncoder: 'Audio Encoder',
    Preset: 'Preset',
    Level: 'Level',
    Scale: 'Scale',
    ProfileAuto: 'Auto',
    GlobalQuality: 'Global Quality',
    VideoEncoder: 'Video Encoder',
    Muxer: 'Muxer',
    VideoCodec: 'Video Codec',
    AudioCodec: 'Audio Codec',
    hasProfileName: 'The profile name already exists, please re-enter.',
    // TokenService&VLAN
    tokenService: 'Token Service',
    creatNewToken: 'Create a new Token',
    ReceiverName: 'Receiver Name',
    ReceiverID: 'Receiver ID',
    ReceiverIP: 'Receiver IP',
    ReceiverPort: 'Receiver Port',
    ReceiverTimeSpan: 'Receiver Time Span',
    ReceiverEmail: 'Receiver Email',
    TransmitterName: 'Transmitter Name',
    TransmitterPID: 'Transmitter PID',
    TransmitterEmail: 'Transmitter Email',
    SaveAs: 'Save As...',
    SetAToken: 'Set a Token',
    CheckTokenInfo: 'Check Token Info',
    SetToken: 'Set Token',
    TokenMessage: 'Token Message',
    ShouldMailedTo: 'Should be mailed to:',
    CopyEmail: 'Copy Email',
    TakeNextToken: 'Take next Token',
    TransmitterValidTime: 'Transmitter Valid Time',
    CreateTime: 'Create Time',
    ExpiredAt: 'Expired at',
    SetValidTime: 'Set Valid Time',
    SureSetNoTime: 'Do you sure about setting the Token valid time to 0?',
    SureDeletePeer: 'Please confirm if you want to delete peer ',
    VLANSetting: 'VLAN Setting',
    IPServicePort: 'IP and Service Port',
    Interface: 'Interface',
    IPMethod: 'IP Method',
    MACAddress: 'MAC address',
    PhysicalInterface: 'Physical Interface',
    IPAddress: 'IP address',
    Mask: 'Mask',
    Gateway: 'Gateway',
    ConfigureIPv4: 'Configure IPv4',
    ConfigureIPv6: 'Configure IPv6',
    EnterIPAddress: 'Enter IP address',
    EnterMask: 'Enter mask',
    EnterGateway: 'Enter gateway',
    IPv4Unavilable: 'IPv4 address not yet assigned by DHCP',
    IPv6Unavilable: 'IPv6 address not yet assigned by DHCP',
    InvalidIPMaskGateway: 'Invalid IP address, mask or gateway format',
    MaxLength40Chars: 'IP address and gateway must be less than 40 characters',
    ConfigureIPv4Failed: 'Failed to configure IPv4',
    ConfigureIPv6Failed: 'Failed to configure IPv6',
    RouterServicePort: 'Router Service Port',
    StopInterface: 'Stop Interface',
    RouterClientList: 'Router Client List',
    DeleteToken: 'Delete Token',
    SelectInterface: 'Select Interface',
    EnterRouterPort: 'Enter Router Service Port',
    NoClients: 'No Clients',
    SureBeUsed: 'will be used for VLAN tunnel server and could not be used for regular live transmission or internet access. Are you sure',
    StartRouterFail: 'Start Router Fail',
    StopRouterFail: 'Stop Router Fail',
    SaveSuccess: 'Save success',
    SaveFail: 'Save Fail',
    PeerName: 'Name',
    IPAdress: 'IP Address',

    RoleManagement: 'Role Management',
    roleName: 'Role Name',
    accounts: 'Accounts',
    devices: 'Devices',
    inputRoleName: 'Role name cannot be empty',
    roleNameError: 'Role name cannot be Co-admin',
    inputPermission: 'Permission cannot be empty',
    editRole: 'Modify',
    createRole: 'Create Role',
    editeRole: 'Edit Role',
    deleteAdmin: 'Are you sure you want to remove the Admin account?',
    deleteIncluld: 'Include its sub-accounts.',
    userAccountTip: 'User account',
    selectAccount: 'Please select user account',
    deleteAccount: 'Are you sure you want to remove this account? ',
    deletetipsPre: 'There are',
    deletetipsLast: 'accounts under this role.Do you still want to delete it?',
    roleNotExist: 'This role name is exist!',
    preTipsUp: 'Are you sure you want to upgrade the account type from ',
    preTipsDown: 'Are you sure you want to downgrade the account type from ',
    afterTipsUp: ' to ',
    afterTipsDown: ' to ',
    // Haran新增Transcriber
    TranscriberText: 'Transcriber',
    Repeat: 'Repeat',
    endRepeat: 'End Repeat',
    halfHour: 'Half an hour',
    anHour: 'An hour',
    allDay: 'All day',
    TranscriberBooking: 'Create Transcriber Booking',
    EndtimeEmpty: 'End time cannot be empty',

    switchSuccess: 'Switch area success,please restart R service',
    removeShare: 'Are you sure to remove the share?',
    parentBookmark: 'Parent\'\s Bookmark',
    otherBookmark: '\'\s Bookmark',
    allAdded: 'All accounts have been added',

    myBookmark: 'My Bookmark',
    // parentBookmark: 'Parent Bookmark',
    startAll: 'Take all',
    rpsTakeAllOccupied: 'The following receivers are already live to another source. Do you want to replace them?',
    rpsTakeAllOccupiedOne: 'The following receiver is already live to another source. Do you want to replace it?',
    rpsTakeAllSkip: 'Skip',
    rpsTakeAllError: 'Take all failed',
    stopAll: 'Stop all',
    bookmarks: 'Bookmarks',
    dragHere: 'Drag source here for device',
    searchReceivers: 'Search \'Receivers\'',
    searchIn: 'Search in',
    warningTitle: 'Warning',
    Reboot: 'Reboot Device',
    RestartBtn: 'Restart Service',
    RebootBtn: 'Reboot System',
    ifRestartService: 'Restart the service may take some time. Do you still want to restart it?',
    ifRebootR: 'Reboot the device may take some time. Do you still want to reboot it?',
    alreadyShare: 'Current account has been shared',
    PairedUnits: 'Paired Units',
    pairedDeviceName: 'Device Name:',
    Update: 'Update:',
    // TimeLock相关
    MainSource: 'Main time source',
    removeMainRTips: 'Warning: once the main time source is removed, the entire TimeLock session will be ended.',
    serverTimeLocking: 'Time locking(Server)',
    clientTimeLocking: 'Time locking(Client)',
    otherOccur: ': this device is already under multi-control with user {userEmail}',
    TimeLockTitle: 'Time Lock',
    failedDevice: 'Device {device} failed to sync.',
    pendingDevice: ' Timelock status unknown for devices {device}.',
    serverIPTiltle: 'Server Device NTP',
    InternalIp: 'Internal IP/Port:',
    ExternallIp: 'External IP/Port:',
    TimeService: 'Time Service',
    ReleaseTimeLock: 'Release Time Lock',
    StillRemove: 'Do you still want to remove it?',
    StillRelease: 'Do you still want to release them?',
    OneReceiverTip: 'TimeLock session will be closed since there’s only one receiver left.',
    ReceiverUsingTimeLock: 'receiver is currently in the TimeLock mode.',
    ThereAre: 'There are',
    CreatedBy: 'Created by',
    At: 'at',
    NullIp: 'Receiver local IP address hasn\'\t been configured in the local configuraton file.',
    sameMachineTip: 'In cases of DualR or QuadR, only one R instance is required to be added to TimeLock.',
    noTimeLockFeature: 'TimeLock feature is not enabled in this device.',
    failedGetIp: 'Getting IP/Port info failed.',
    NotDevice: 'Device does not exist',
    NotTR: 'Device must be a Pack or a Receiver',
    MoreThanTwo: 'The number of receivers must be greater than two',
    AccountSynchronizing: 'Your account is Synchronizing',
    // deviceSynchronizing: 'Exist device synchronizing'
    IpSynchronizing: 'Exist intranet ip synchronizing',
    failedGetFeature: 'Verifying TimeLock feature failed.',
    notSynchronizing: 'Not synchronized. ',
    failedGetMainR: 'Failed to get main R with the time service.',
    mainRcantRemove: 'Main R with the time service cannot be removed.',
    syncSuccess: 'Synchronization success',
    removeSyncSuccess: 'Synchronization removal success',
    sourcePeerId: 'Source PeerID',
    noPermission: 'Sorry, you do not have permission to remove.',
    otherOccurDevices: 'are currently time locked by user',
    askUsersRelease: 'Please ask these users to release the receivers before proceeding.',
    askUserRelease: 'Please ask this user to release the receivers before proceeding.',
    // ecoPreview
    ecoPreviewBtn: 'Eco-Preview',
    exitPreviewBtn: 'Exit-Preview',
    editTime: 'Edit Timer',
    previewSetting: 'Economy Preview-Timer Setting',
    timer: 'Timer',
    laterPreview: ' mins later to auto-exit preview.',
    remainPreview: 'remain in preview mode until manually exit.',
    visitWebR: 'Visit WebR',
    refreshIP: 'Refresh IP mapping',

    pictureSize: 'Picture size must be smaller than 480×640',
    offsetX: 'X offset',
    offsetY: 'Y offset',

    // transcribre
    CaptionPosition: 'Caption Position:',
    Lower: 'Lower',
    Upper: 'Upper',
    wordReplace: 'Enable Word Replacement:',
    ManageTxt: 'Manage',
    speakerRecogition: 'Speaker Recognition:',
    onlySupportEng: 'Only supports recognition of English language when this feature enabled.',
    scheduleTimeTxt: 'Scheduled time',
    MayInterruptLive: 'Enabled Transcriber or delay changes may interrupt live, please confirm to continue setting?',
    SetSmartCaption: 'Set smartCaption',
    lowerAdd: 'add',
    startTimeEmpty: 'Please select start time',
    endTimeEmpty: 'Please select end time',
    CaptionFontFamily: 'Caption font family',
    wordReplacement: 'Word Replacement',
    OriginalWord: 'Original Word',
    ReplacedWord: 'Replaced Word',
    PleaseInputWord: 'Please input word',
    outputStreaming: 'The output is streaming, please stop first',
    encoderOneNDI: 'Each encoder can only have one NDI',

    ExternallOnlyIp: 'External IP',
    ExternallPort: 'External Port',
    LocalIP: 'Local IP',
    LocalPort: 'Local Port',
    controlAndPort: 'Web Control & Stream Port',
    restartToEffect: 'Please restart the receiver service for the setting to take effect',
    customLogo: 'Custom Logo',
    videoBitDepth: 'Video bit depth',
    stayLastFrame: 'Stay on last frame during transmission interruption',
    VLANClientInfo: 'VLAN Client Info',
    VLANInterface: 'VLAN Interface:',
    VLANMAC: 'VLAN MAC:',
    IPLabel: 'IP:',
    MASKLabel: 'MASK:',
    VLANServerInfo: 'VLAN Server Info',
    ServerIPHost: 'Server IP or Host',
    PortLabel: 'Port',
    connectServer: 'Connection to the VLAN Server',
    ConnectedDevices: 'Connected Devices',
    VLANClient: 'VLAN Client',
    ConnectBtn: 'Connect',
    beUserdVLAN: ' will be used for VLAN tunnel server and could not be used for regular live transmission or internet access. Are you sure',
    MainLevel: 'Main Level',
    IPAndRPort: 'Receiver IP & Port',
    getIP: 'Get IP',
    InputContent: 'please input content',
    gridDescriptionRight: 'Open Event description popup when start/stop live',
    limitBelow: 'Please keep the image below {0} kb',
    pleaseUploadPic: 'Please upload a picture first',

    updateSlugFailed: 'Update description failed',
    gridTitle: 'Event',

    byChosen: 'By Chosen Order',
    byName: 'By Name',
    byStatus: 'By Status',

    Advanced: 'Advanced',
    AdvancedEtc: 'Advanced...',
    bufferSize: 'Receive Buffer Size',
    connectTimeout: 'Connect Timeout',
    rwTimeout: 'RW Timeout',
    passphrase: 'Passphrase',
    additional: 'Additional',
    advancedParameters: 'Advanced Parameters',
    latencyOptional: 'Latency (optional)',
    packetSize: 'Packet Size',
    IPDomain: 'IP (domain)',
    Stream: 'Stream',
    bytes: 'bytes',
    shareFeedBack: 'Share Your Feedback',

    sameExtName: 'This Ext already exists, duplicate of {name} source',
    realTrackCantChange: 'Switching language in real time mode may cause track deviations. Please use it carefully.',
    startNewEvent: 'Are you sure you want to start a new event?',
    replaceEvent: 'Are you sure you want to start a new event? The current event will be stopped',
    stopEvent: 'Are you sure you want to stop this event?',
    updateEvent: 'Are you sure you want to update the current event’s settings?',
    SDIFormat: '3G-SDI formats',
    ReceiverLiveWithOther: 'Would you like to start LIVE with the new source now?',
    /* General */
    EasternTime: 'Eastern Standard Time',
    NTPService: 'Custom NTP Service',
    NTPContent: 'NTP uses system services by default. You can<br />turn on the Custom NTP Service to change it. <br />Please note that if the device has enabled<br />Time lock, NTP will do not take effect.',
    DomainName: 'IP/ Domain name',
    NTPOccupy: 'This device has enabled Timelock, the time will be based on {name}',
    stopTips: 'Prompt a Warning When Stopping a Live Transmission',
    defaultDelay: 'Default Delay and Bitrate',
    switchRegionTips: 'Switching region will require restarting the receiver service.',
    confirmSwitch: 'Yes, I want to switch',
    NTPEnterTips: 'Please enter the NTP Server IP/domain name and port',
    DelaySecond: 'Delay (second)',
    BitrateKbps: 'Bitrate (kbps)',
    insertScte: 'insert scte when black frame appears',
    preroll: 'preroll (ms)',
    liveOnHold: 'Switch live on hold to standby',
    talkBack: 'Talkback',
    talkNote: 'Note: if the transmitter accepts IFB only, then the talkback connection would still be IFB in this mode',
    talkNoteVOIP: 'Note: if the transmitter accepts VoIP only, then the talkback connection would still be VoIP in this mode',
    Buffersizems: 'Buffer size (ms)',
    videoFeeback: 'Video Feedback',
    BackStr: 'Back to Classic UI',
    backgroundMode: 'Background Mode',
    DarkMode: 'Dark Mode',
    LightMode: 'Light Mode',
    CustomBackground: 'Custom Background Logo',
    OnlyPng: 'Only supports png format',
    NoAudioMix: 'No Audio Mix',
    EnabledAudioMix: 'Enable this when you want the audio channels to be completely independent from each other.Make sure the same setting is enabled on the transmitter for this to take effect.',
    // Log list
    logList: 'Log',
    networkConnection: 'Network Connection',
    // Passthrough Streaming
    passThroughStream: 'Passthrough Streaming',
    Protocol: 'Protocol',
    Mode: 'Mode',
    Caller: 'Caller',
    Listener: 'Listener',
    ListenerPortTip: 'Listener port range must be from 60000 to 65000',
    IpNotEmpty: 'IP can not be empty',
    portNotZero: 'Port can not be 0',
    delayTip: 'SRT delay range must be from 20ms to 8000ms',
    // Remote File Storage
    remoteFileStorage: 'Remote File Storage',
    DestinationName: 'Destination Name',
    accessKeyId: 'Access Key ID',
    parallelThread: 'Parallel Thread',
    secretAccessKey: 'Secret Access Key',
    dataConnType: 'Data ConnType',
    autoPassive: 'Auto Passive',
    cannotEmpty: 'Can not input empty value',
    destinationManage: 'Destination Management',
    keyOrUserName: 'Key ID/User Name',
    keyPassword: 'Key/Password',
    uploadPreferences: 'Upload Preferences',
    destinationManagemention: 'Destination Management',
    uploadDestination: 'Upload Destination',
    deleteAfter: 'Delete After Upload',
    remoteDirectory: 'Remote Directory',
    uploadRecord: 'Upload Record',
    uploadModule: 'Module',
    retry: 'Retry',

    FollowLive: 'Follow Receiver Live/Stop',

    Route: 'Route',
    Monitor: 'Monitor',
    Grid: 'TVU Grid',
    RPSOne: 'RPS One',
    RPS: 'RPS',
    RPSAndLink: 'RPS / RPS Link',
    menuNoPermission: 'Please contact support for authorization.',
    mvNoPermission: 'Currently you are not licensed for this feature, please contact support for more information.',
    tkNoPermission: 'Currently you are not licensed for this feature, please contact support for more information.',
    bookingFilter: 'Filter',
    i18n_destination: 'Destination',

    ipPortTip: '(All receiver instances use the same port-mapping for web access)',
    ipregex: 'Please input the correct IP',

    restartLater: 'Apply and Restart Later',
    restartNow: 'Apply and Restart Now',
    changeFeatureTips: 'Changing the features will require restarting the receiver service to take effect.',
    preAssignPid: 'Pre-assign PID',
    durationHour: 'Duration(hours)',
    trackTips: '(Only supports the latest month’s data)',
    confirmModeChange: 'Are you sure you want to use {mode} mode?',
    keepRestart: 'Keep the relevant configurations after shut-down',
    Restore: 'Restore',

    onlineNotify: 'Equipment Online Notification',
    offlineNotify: 'Equipment Offline Notification',
    advanceControlOption: 'Advanced Control',
    openWebR: 'Open Web Receiver (applicable to receiver software version 7.8 and below, if and when the web port of the receiver is open)',
    release: 'Release',
    // workbench
    CreateCloudR: 'Create a Cloud Receiver',
    CloudReceiver: 'Cloud Receiver',
    Custom: 'Custom',
    DoesNotRepeat: 'Does not repeat',
    Daily: 'Daily',
    EveryWeekday: 'Every weekday (Monday to Friday)',
    EveryWeekend: 'Every weekend (Saturday and Sunday)',
    RepeatEvery: 'Repeat every',
    RepeatOn: 'Repeat on',
    Ends: 'Ends',
    Never: 'Never',
    After: 'After',
    occurrences: 'occurrences',
    MonthlyOnDay: 'Monthly on day {Day}',
    MonthlyOnWeek: 'Monthly on the {SeveralFew} {WeeksSeveral}',
    first: 'first',
    // second: 'second',
    third: 'third',
    fourth: 'fourth',
    fifth: 'fifth',
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday',
    Sunday: 'Sunday',
    EveryFewDays: 'Every {number} days',
    AWeekAFew: 'Weekly on {week}',
    EveryFewWeeks: 'Every {number} weeks on {week}',
    MonthlyDay: 'Monthly on day {day}',
    MonthlyFirstWeeks: 'Monthly on the {first} {week}',
    EveryMonthlyDay: 'Every {number} months on day {day}',
    EveryMonthlyFirstWeeks: 'Every {number} months on the {first} {week}',
    HowTimes: ', {times} times',
    UntilTime: ', until {time}',
    fromUntil: 'from {start} until {end}',
    fromLess: 'from {start}',
    setStartEnd: 'Please set the start-up and shut-down time',
    setStart: 'Please set the start-up time',
    selectFuture: 'Please select a future time',
    startUpperStopTime: 'Start-up time must be earlier than shut-down time',
    startUpperEndDate: 'From date must be earlier than end date',
    selectAdmin: 'Please select the admin account to assign',
    saveFirst: 'Please save the schedule settings first',
    onlyOne: 'Only this time',
    allSchedule: 'All the schedule time',
    confirmDeleteCloudR: 'Are you sure you want to delete it?',
    cloudRLimit: 'You have reached the limit of {num}. Please delete some of the unused Cloud Receivers first.',
    adminCloudLimit: '{name} has reached the limit of {num}. Please delete some of the unused Cloud Receivers first.',
    gotIt: 'Got it',
    createProject: 'Create Cloud Receiver',
    editProject: 'Edit Cloud Receiver',
    projectName: 'Cloud Receiver Name',
    inputInstanceName: 'Please input Cloud Receiver name',
    startingWait: 'Starting now. Please wait.',
    upgrade: 'Upgrade',
    addSources: 'Add Sources',
    cloudRPrepar: 'The Cloud Receiver is already preparing, whether start to add the sources?',
    notNow: 'Not now',
    upgradeTo: 'Upgrade to',
    updateNow: 'Update Now',
    installing: 'Installing Update...',
    pairFail: 'failed to pair',
    pairSuccess: 'Paired Success',
    fixedIP: 'Fixed IP',
    fixedIPTips: 'Extra charge may apply if a fixed IP is preferred',
    fixedIPLimit: 'There is no fixed IP address available, please cancel the fixed IP option',
    confirmReleaseIP: 'Are you sure you want to release the fixed IP?',
    operateSuccess: 'Operate success',
    noMatch: 'No Data',
    updateSuccess: 'Update successfully',
    addSuccess: 'Add successfully',
    audioAutoplayPolicy: 'Audio autoplay policy',
    audioAutoplayPolicyText:
      ' Audio autoplay is not allowed because the limitation of browser. Please click the button "Allow" to get audio stream.',
    allow: 'Allow',
    view: 'View',
    hardware: 'Hardware',
    NoSource: 'No video source available',
    signOutAuto: 'Page Never Times Out',
    errorNotify: 'Transmission Error Notification',
    lowBatteryNotify: 'Low Battery Level (<20%) Notification',
    transmissionError: 'Transmission Error',
    batteryError: 'Low Battery Level',
    noData: 'No results. Please check your search criteria and filter settings.',
    noScheduleTime: 'Please set the Schedule time',
    IpStreamOut: 'IP Stream Out',
    sourceFormat: 'Source Format',
    Start: 'Start',
    Edit: 'Edit',
    StreamName: 'Name',
    inputPlaceholder: 'Enter Output name or URL address',
    inputNickName: 'Please input Output name',
    warnAddMsg: 'Nickname or stream url cannot be empty',
    IPStreamOutloading: 'Loading...',
    videoLogo: 'Upload video logo completed',
    pushSameStream: 'Push stream failed, the current input url is pushing',
    profileManage: 'Profile Management',
    AudioBitrate: 'Audio Bitrate',
    FrameRate: 'Frame Rate',
    Profiles: 'Profile',
    Add: 'Add',
    Back: 'Back',
    Yes: 'Yes',
    No: 'No',
    Auto: 'Auto',
    MustProfileName: 'Please input Profile name',
    logo: 'logo',
    Source: 'Source',
    presetSuccess: 'Preset successfully!',
    cancelPresetSuccess: 'Cancel preset successfully!',
    presetted: 'This receiver has been pre-selected to go live with source ',
    sureRepreset: 'Are you sure you want to pre-select this pack to go live with this receiver?',
    surePreset: 'Are you sure you want to select the offline device?',
    presetNote: 'Please note: this device will go live automatically when it comes online.',
    recordMetaData: 'Record Metadata',
    inputTitle: 'Please input title',
    inputDescription: 'Please input description',
    shareEmails: 'Email of your group members',
    returnVideo: 'Return Video',
    voip: 'VoIP',
    gridLogs: 'Live logs',
    Untop: 'Untop',
    Top: 'Top',
    topSuccess: 'successfully pinned',
    untopSuccess: 'successfully unpinned',
    topMax: 'The maximum of {maxNum} sources can be pinned to the top',
    playSound: 'Play sound when prompted',
    autoClear: 'Auto clear Battery notification after 10 seconds',
    headlessLiveTip: 'Please visit other TVU services such as MediaHub or Producer etc to manage transmissions to non-standard receivers.',
    dontSupportVoip: 'Doesn’t support VoIP',
    // WiFi module
    ConfirmRemoveWiFi: 'Are you sure you want to remove the WiFi network "{0}"?',
    ConnectToWifiBeforeLocking: 'No WiFi connected, please connect to WiFi before locking.',
    ok: 'OK',
    FindJoinWiFi: 'Find and join WiFi network',
    LockCurrentWiFi: 'Lock to current WiFi',
    'wifi.Slot': 'Slot',
    WiFiConnectionFailed: 'The WiFi network "{0}" cannot be connected.',
    TurnOffWifiSuccessfully: 'Turn off wifi successfully',
    TurnOnWifiSuccessfully: 'Turn on wifi successfully',
    Success: 'Success',
    Failed: 'Failed',
    NoData: 'NoData',
    connected: 'Connected',
    ContinuousAttempt: 'Continuously attempt to connect to WiFi "{0}" until connected.',
    enterPassword: 'Enter password',
    enterPasswordFor: 'Enter the password for {0}',
    enterTheNetworkName: 'Enter the network name',
    networkInfo: 'Network Info',
    networkName: 'Network Name',
    networkSettingsForSlotDataId: 'Network Settings for slot {0}',
    // password: 'Password',
    RememberNetwork: 'Remember this network',
    ShowPassword: 'Show password',
    // Additional WiFi module translations
    Scan: 'Scan',
    Disconnect: 'Disconnect',
    Security: 'Security',
    enterSecurity: 'Enter security',
    Remove: 'Remove',
    ReenterPassword: 'Re-enter password',
    tryAgain: 'Try again',
    OnboardWiFi: 'Onboard',
    noSecurity: 'No security',
    Other: 'Other',
    removeFailed: 'Remove failed',
    Join: 'Join',
    wifiLoading: 'Loading',
    ConnectedSuccess: 'Connected success',
    Connected: 'Connected',
    Disconnected: 'Disconnected',
    DisconnectedSuccess: 'Disconnect success',
    Disconnecting: 'Disconnecting',
    'Disconnect failed': 'Disconnect failed',
    browserNotCopy: 'This browser does not support automatic copying.',
    // Hotspot
    Hotspot: 'Hotspot',
    Bandwidth: 'Bandwidth',
    ConnectedClients: 'Connected Clients',
    NoDevice: 'No device',
    hotspotNameRequired: 'Please enter network name',
    passwordRequired: 'Please enter password',
    hotspotInvalidNameChars: 'Name cannot contain special characters: %&*,;()\'"><',
    hotspotNameBytesExceeded: 'Name length limit reached (32 bytes). You can\'t enter more.',
    hotspotPasswordRequirements: 'Password must be 8-63 characters (letters, numbers, or underscores)',
    HotspotEnableSuccess: 'Hotspot enabled successfully',
    HotspotDisableSuccess: 'Hotspot disabled successfully',
    // VLAN / LAN Settings（VLAN 需求，文案对齐 Figma 终稿 + newconfigt en.json）
    SubnetMask: 'Subnet Mask',
    LanSettingRouter: 'Router',
    LanSettingApplyConfirm: 'Changing LAN settings may cause a temporary network disconnection. Are you sure you want to continue?',
    ReconnectNotice: 'Apply success! Please reconnect to the network and use the new IP address to access this system.',
    SubnetSetDone: 'Subnet set done',
    IPAddressInvalid: 'IP Address is invalid',
    SubnetMaskInvalid: 'Subnet Mask is invalid',
    LanUnavailableTip: 'It\'s unavailable, you can turn off the switch mode or enable it as a DHCP server to use it.',
    VLANServer: 'VLAN Server',
    SelectReceiver: 'Select Receiver',
    serverPortOfReceiver: 'Server port of Receiver',
    ServerPort: 'Server Port',
    AsDhcpServer: 'As DHCP Server',
    VlanNoData: 'No Data',
    VlanYes: 'Yes',
    BandwidthLimit: 'Bandwidth Limit',
    OnlyViaEthernet: 'Only via Ethernet',
    SwitchModeLayer2: 'Switch Mode (Layer 2)',
    VlanTips: 'Tips',
    DHCPWarning1: '• To ensure successful connectivity, only one device can be set as a DHCP server.',
    DHCPWarning2: '• In Switch mode, Hotspot is only available when this device is set as a DHCP server.',
    CautionSwitchMode: 'Caution: Only enable the "switch" function if you fully understand it. Improper use may crash your network.',
    NetworkDisconnection: 'This operation will disconnect network for several seconds.',
    TurnOnSwitchMode: 'Turn on Switch mode?',
    TurnOffSwitchMode: 'Turn off Switch mode?',
    TurnOn: 'Turn On',
    TurnOff: 'Turn Off',
    ConfirmDisableDhcp: 'Are you sure you want to disable "As DHCP Server"?',
    HotspotUnavailable: 'If yes, then this hotspot will not be available.',
    VLANServerError: 'The VLAN server is missing necessary information!',
    vlanServerPortIncorrect: 'Incorrect VLAN server port detected. Please correct the port number.',
    SelectAnotherServer: 'Can\'t connect to the server, please select another server or try again.',
    RetryLater: 'Cannot connect to server, please try again later.',
    ConnectSuccess: 'Connect success',
    ConnectingStatus: 'Connecting...',
    ServerInfo: 'Server Info',
    VlanServerDisconnected: 'Disconnected',
    SetSuccess: 'Set success.',
    globalSetting: 'Global Settings',
    videoFormat: 'Video Format',
    // CC-2282: 同一接收机的同一信号源（SDI/Pack）不能用于两路回传输出 [Claude Code]
    sameRTip: 'The same source (SDI/Pack) on the same receiver cannot be used for both return video outputs.',
    // CC-2291: 改 Video Format 后已启用路需重启才能生效，弹此确认框 [Claude Code]
    formatChangeInterruptTip: 'Switching the video format will briefly interrupt the return video. Do you want to switch now?',
    // CC-2291 补：重启（stop/start）任一步失败时提示，避免 UI 与设备状态静默分叉 [Claude Code]
    formatChangeRestartFailed: 'Failed to switch the video format. The return video may be interrupted. Please check the device status.',
    switchMode: 'Source Switch Mode',
    switchTip: 'Switch source 1, 2, 3 & 4 on touchscreen to output to a single Receiver;Outputting each source to unique receivers is not possible in this mode.',
    switchTip1: 'All video formats and frame rates must be the same to use this function.',
    switchTip2: 'Via shortcut keys 1, 2, 3, 4 to switch sources quickly.',
    NoAutoReconnect: 'This network will not reconnect automatically. You will have to enter the password again if you want to use it later.',
    LockWiFiNote: '*Enable to connect only to this WiFi network.',
    RTMP: 'RTMP(s)',
    RTSP: 'RTSP',
    UDP: 'UDP',
    NetworkRegistrationMode: 'Network registration mode',
    RoamingSingle: 'Roaming for this modem',
    Carrier: 'Carrier',

    /* ---- RVF & VoIP Module ---- */
    RVFVoIP: 'RVF & VoIP',
    OnboardHDMI: 'Onboard HDMI',
    VBox: 'V-Box (output video via the external USB-HDMI adapter)',
    LCDScreen: 'LCD Screen',
    VideoFrom: 'Video From',
    Destination: 'Destination',
    RvfDestination: 'Destination',
    ProducerProgram: 'Producer Program',
    PartylineSource: 'Partyline Source',
    DeviceNotAddedToProducerProgram: 'This device is currently not added to any Producer program',
    DeviceNotAddedToPartylineProgram: 'This device is currently not added to any Partyline program',
    DeviceNotAddedToMediaHubProgram: 'This device is currently not added to any MediaHub program',
    RVFStatus: 'RVF Status',
    RVFVersion: 'RVF Version',
    NewVersionAvailable: 'New version available!',
    NewRvfAdapterVersionAvailable: 'New RVF Adapter version available!',
    ContactSupportToUpgradeRvfAdapter: 'For a better user experience, contact {0} Support to upgrade your RVF Adapter.',
    ResolutionTooHigh: 'Return Video Feed resolution is too high coming from the receiver.',
    LowerResolution: 'Please lower the resolution to 720P on the R side to ensure optimal decoding performance.',
    VoIPMode: 'Mode',
    VoIPAuto: 'VoIP (Auto)',
    VoIPAutoTipDesc: 'Auto: auto-select the VoIP technology, based on the receiver software versions.',
    VoIPAutoTipWarn: 'Please note that device reboot is required when switching between VoIP and IFB if the receiver version is lower than 8.2',
    LegacyVoIP: 'Legacy VoIP',
    IFBLabel: 'IFB',
    MicAndSpeaker: 'Microphone & Speaker',
    AudioSetting: 'Audio Setting',
    Transmitter: 'Transmitter',
    EmbeddedAudio: 'Embedded Audio',
    EmbeddedAudioTip: 'To transmitter 1',
    AudioLevel: 'Audio Level',
    MixingAllChannels: 'Mixing All Channels (Default)',
    AllChannelsWithoutMixing: 'All Channels without Mixing',
    LeftChannel: 'Left Channel',
    RightChannel: 'Right Channel',
    Channel12WithoutMixing: 'Channel 1-2 Active without Mixing',
    Channel1: 'Channel 1',
    Channel2: 'Channel 2',
    Channel3: 'Channel 3',
    Channel4: 'Channel 4',
    MixingChannel12Default: 'Mixing Channel 1-2 (Default)',
    Default: 'Default',
    BuiltIn: 'Built-in',
    Scanning: 'Scanning',
    Transmitters: 'Transmitter {0}',
    CH: 'CH {0}',
    EnableIndependentChannels: 'Enable this when you want the audio channels to be completely independent from each other. Make sure the same setting is enabled on the receiver for this to take effect.',
    SelectedChannelReplacedTip: 'Selected channel will be replaced if another transmitter is already using it.',
    checkRunningFailed: 'Failed to check call status',
    removeSuccess: 'Removed successfully',
    RemoveRowTip: 'Remove {0}?',
    Bluetooth: 'Bluetooth',
    Devices: 'Devices',
    VoIPSwitchConfirm: 'This operation will interrupt the current call for a moment. Are you sure you want to switch now?',
    Refresh: 'Refresh',
    VoIPSwitch: 'Switch',
    VoIPCancel: 'Cancel',
    RvfReceiver: 'Receiver',
    Producer: 'Producer',
    Partyline: 'Partyline',
    MediaHub: 'Media Hub',
    LiveStream: 'LiveStream',
    SourceFrom: 'Source From',
    SelectAReceiver: 'Select a Receiver',
    SelectReceiverFirst: 'Please select a receiver first',
    None: 'None',
    Automatic: 'Automatic',
    NoBluetoothDevice: 'No Bluetooth device found',
    Paired: 'Paired',
    RemoveBluetoothConfirm: 'Are you sure you want to remove this Bluetooth device?',
    RemoveDeviceTitle: 'Remove Device',
    connectSuccess: 'Connected successfully',
    connectFailed: 'Connection failed',
    SlotSelection: 'Slot Selection',
    SelectVideo: 'Select Video',
    MainWindow: 'Main Window',
    MediaHubDestination: 'Media Hub Destination',
    PartylineIdLabel: 'Partyline ID',
    SourceIndex: 'Source {0}',
    DeviceNotInProducer: 'Device not added to Producer Program',
    DeviceNotInPartyline: 'Device not added to Partyline',
    DeviceNotInMediaHub: 'Device not added to MediaHub',
    Disabled: 'Disabled',
    Mono: 'Mono',
    Stereo: 'Stereo',
    AudioOnly: 'Audio Only',
    IpSourceCurrentlyTip: 'IP Source currently does not support Mono and will use Stereo instead. Continue?',
    AudioChannel: 'Audio Channel',
    AudioVBRCBR: 'Audio VBR/CBR',
    VideoEncode: 'Video Encode',
    AudioEncode: 'Audio Encode',
    Encoding: 'Encoding',
    ChromaSubsampling: 'Chroma Subsampling',
    WebCamOrIPSourceDoesntSupport422: 'WebCam or IP Source doesn’t support 4:2:2.',
    SettingFailedValidColorgamut: 'Setting failed! a valid colorgamut parameter is required.',
    AudioOutputMapping: 'Audio output mapping',
    AudioMapCH: 'CH {0}',
    // WR-278 Apple Watch device activation
    TActivateDevice: 'Activate Device',
    AppleWatch: 'Apple Watch',
    activationTime: 'Activation time',
    operate: 'Operation',
    Confirm: 'Confirm',
    watchActivateTitle: 'Activate Device',
    watchActivateTip: 'Enter the code displayed on your Watch screen.',
    watchCode: 'Code',
    watchContinue: 'Continue',
    watchActivateSuccess: 'Your Watch has been activated. You can return to your Watch.',
    watchStatusActive: 'Active',
    watchStatusPending: 'Pending',
    watchStatusInvalid: 'Invalid',
    watchActivateDialogTitle: 'Activate My Watch',
    watchActivateFailed: 'Activation failed. Please try again.',
    watchCodeInvalid: 'Invalid code. Please check and try again.',
    watchCodeExpired: 'This code has expired. Please restart activation on your Watch.',
    watchCodeUsed: 'This code has already been used.',
    watchRemoveConfirmTitle: 'Are you sure you want to remove this Watch?',
    watchRemoveConfirmLose: '"{0}" will lose access immediately.',
    watchRemoveConfirmReactivate: "You'll need to activate it with the new Watch code if you want to gain access again.",
    watchRemoveFailed: 'Failed to remove the Watch. Please try again.',
    lowVersionRefreshTips: 'Please note: versions prior to 7.5 do not support automatic refresh',
    // WR-323: 接收机实时预览禁用提示 [Claude Code]
    livePreviewDisabledHint: 'Video preview is currently disabled on this particular receiver to save resources. Please go to this receiver and enable it in the receiver setting if needed.',
    // WR-323: 设置里禁用实时预览开关 label + 帮助 tooltip [Claude Code]
    disableLivePreviewLabel: 'Disable Live Video Preview to Save Hardware Resources',
    disableLivePreviewTip: 'Please note that this option will disable live video previews on all services including the receiver web control and the Command Center for this particular receiver'
  }
}
